import axios from 'axios';
import { urlApiAsesoria } from '../Config/baseUrl';
import { IListarPodCasts } from '../Interfaces/IPodcasts';

const instance = axios.create({
  baseURL: urlApiAsesoria,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const listarPodCasts = (data: IListarPodCasts) => {
  return instance.post('fit4/listarPodCasts', data);
};
